import { render, staticRenderFns } from "./contentTable.vue?vue&type=template&id=0965f503&"
import script from "./contentTable.vue?vue&type=script&lang=js&"
export * from "./contentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports